import { useDispatch } from 'react-redux';
import useFetchConfig from './useFetchConfig';

import { lockChallenge, unlockChallenge } from 'features/auth/slice';

import { recordsMatch } from '@frontendmentorio/design-system-v2';

export default function useChallenges() {
  const dispatch = useDispatch();
  const { mutate } = useFetchConfig();

  const lock = async (challenge) => {
    const res = await fetch(`/api/v3/challenges/${challenge.id}/lock`, {
      headers: { 'Content-Type': 'application/json' },
      method: 'POST',
    });

    const body = await res.json();

    if (!res.ok) throw new Error(body.message);

    await dispatch(lockChallenge(challenge));

    await mutate(
      '/api/v3/learner/challenges/in-progress',
      async ({ data, ...rest }) => ({
        data: data.filter((challenge) => !recordsMatch(challenge, body.data)),
        ...rest,
      }),
      { revalidate: false }
    );
  };

  const unlock = async (challenge) => {
    const res = await fetch(`/api/v3/challenges/${challenge.id}/unlock`, {
      headers: { 'Content-Type': 'application/json' },
      method: 'POST',
    });

    const body = await res.json();

    if (!res.ok) throw new Error(body.message);

    await dispatch(unlockChallenge(challenge));
    await mutate('/api/v3/learner/challenges/in-progress');
  };

  return { lock, unlock };
}
